export const TEMP_CONSERVATION_DEFAUT = '-18°C (congelé)';

export const DUREES_CONSERVATION_MOIS = {
  porc: 6,
  saucisse: 3,
  cotes_levees: 6,
  brisket: 6,
  sauce: 12,
  saumon: 3,
};

export const LIBELLES_OPERATEURS = {
  LCU: 'Louis-Charles Cuierrier (LCU)',
  ELA: 'Étienne Lapointe (ELA)',
  'LCU+ELA': 'Louis-Charles Cuierrier + Étienne Lapointe',
};

export function ajouterMois(dateIso, mois) {
  if (!dateIso || !mois) return '';
  const date = new Date(`${dateIso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return '';

  const jour = date.getDate();
  date.setMonth(date.getMonth() + mois);
  if (date.getDate() !== jour) date.setDate(0);

  return date.toISOString().slice(0, 10);
}

export function calculerDateExpirationProduit(produit, dateCongelation) {
  return ajouterMois(dateCongelation, DUREES_CONSERVATION_MOIS[produit]);
}

export function getMentionExpiration(produit) {
  const mois = DUREES_CONSERVATION_MOIS[produit];
  return mois ? `Basé sur : congélation + ${mois} mois` : '';
}

export function calculerDureeProduction(heureDebut, heureFin) {
  if (!heureDebut || !heureFin) return '';
  const [hd, md] = String(heureDebut).split(':').map(Number);
  const [hf, mf] = String(heureFin).split(':').map(Number);
  if ([hd, md, hf, mf].some((n) => Number.isNaN(n))) return '';

  let minutes = (hf * 60 + mf) - (hd * 60 + md);
  if (minutes < 0) minutes += 24 * 60;

  return `${Math.floor(minutes / 60)}h${String(minutes % 60).padStart(2, '0')}`;
}

export function creerFormulaireTraiteCreation() {
  return {
    lot_fournisseur: '',
    date_achat_matiere: '',
    date_expiration_matiere: '',
    operateurs: 'LCU',
    heure_debut: '',
    heure_fin: '',
  };
}

export function creerFormulaireTraiteFinal(produit) {
  const aujourdHui = new Date().toISOString().slice(0, 10);
  return {
    date_congelation: aujourdHui,
    date_expiration_produit: calculerDateExpirationProduit(produit, aujourdHui),
    temp_conservation: TEMP_CONSERVATION_DEFAUT,
    incident: '',
  };
}
